import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, HammerModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HammerConfig } from './hammer-config';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageHolderModule } from './page-holder/page-holder.module';
import { SocialLoginModule } from './social-login/social-login.module';
import { SystemModule } from './system/system.module';

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
		MatButtonModule,
		MatIconModule,
		PageHolderModule,
		SocialLoginModule,
		SystemModule,
		AppRoutingModule,
		HammerModule, // Add HammerModule here
	],
	providers: [
		{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: HammerConfig,
		},
		provideZoneChangeDetection(),
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
